const styles = theme => {
  return {
    accordion: {
      width: ' 100%',
      marginBottom: '10px',
      boxShadow: 'unset !important',
      borderRadius: '4px',
      backgroundColor: '#FAFAFA'
    },
    accordionSummary: {
      display: 'flex',
      alignItems: 'center'
    },
    accordionDetailsRoot: {
      padding: '8px',
      display: 'flex',
      flexDirection: 'column'
    },
    accordionIcon: {
      fontSize: '24px',
      paddingLeft: '5px',
      marginRight: '5px'
    },
    showMoreIcon: {
      fontSize: '16px'
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      marginBottom: '10px'
    },
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
    },
    searchField: { borderRadius: '4px' },
    closeIcon: {
      cursor: 'pointer'
    }
  };
};

export default styles;

export const customSelectStyles = {
  container: { width: '100%' },
  option: {
    fontSize: '12px',
    display: 'flex'
  },
  valueContainer: {
    fontSize: '14px',
    display: 'flex',
    borderRadius: '5px'
  },
  indicatorSeparator: { display: 'none' },
  control: { borderRadius: '5px' },
  menu: { zIndex: 100 }
};

export const customStyles = {
  textfieldRoot: {
    marginTop: '0',
    backgroundColor: '#fff',
    paddingRight: '10px'
  }
};
